import { render, staticRenderFns } from "./AttributeSets.vue?vue&type=template&id=5bba6178&scoped=true&"
import script from "./AttributeSets.vue?vue&type=script&lang=js&"
export * from "./AttributeSets.vue?vue&type=script&lang=js&"
import style0 from "./AttributeSets.vue?vue&type=style&index=0&id=5bba6178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba6178",
  null
  
)

export default component.exports